import Title from '../components/Title/Title';
// import SimpleTitle from '../components/Title/SimpleTitle';
import Projects from '../components/Projects/project';
import realisation from '../assets/content/realisations.json';

const Projets = () => {
 
  return (
    <div class="projets">
      <Title title={realisation.title} variant={realisation.variant} />
      
      <div className="bloc">
        {/* <SimpleTitle title="Développement" variant="green" position="left" /> */}
        
        <div className={`realisations-grid ${realisation.variant}`}>
          {realisation.realisations.map((item, index) => (
            <Projects
              key={index}
              image={item.image}
              alt={item.alt}
              nom_real={item.title}
              description={item.description}
              link={item.link}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projets;
